var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDespachosSemana(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 10,
    fill: "#17656A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 17H33M14.3333 9V11.6667M27.6667 9V11.6667M13 22.3333H15.6667M13 27.6667H15.6667M19.6667 22.3333H22.3333M19.6667 27.6667H22.3333M26.3333 22.3333H29M26.3333 27.6667H29M13.2667 33H28.7333C30.2268 33 30.9736 33 31.544 32.7093C32.0457 32.4537 32.4537 32.0457 32.7093 31.544C33 30.9736 33 30.2268 33 28.7333V15.9333C33 14.4399 33 13.6931 32.7093 13.1227C32.4537 12.6209 32.0457 12.213 31.544 11.9573C30.9736 11.6667 30.2268 11.6667 28.7333 11.6667H13.2667C11.7732 11.6667 11.0265 11.6667 10.456 11.9573C9.95425 12.213 9.54631 12.6209 9.29065 13.1227C9 13.6931 9 14.4399 9 15.9333V28.7333C9 30.2268 9 30.9736 9.29065 31.544C9.54631 32.0457 9.95425 32.4537 10.456 32.7093C11.0265 33 11.7732 33 13.2667 33Z",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDespachosSemana);
export default __webpack_public_path__ + "static/media/iconDespachosSemana.53647143dacf80655eaa1d6c2ea728df.svg";
export { ForwardRef as ReactComponent };